var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccessories = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.4 24c-.4 0-.7-.1-1-.4l-4-4c-.6-.6-.6-1.5 0-2L4 14c-.2-.6-.2-1.3-.2-1.9 0-4.5 3.7-8.2 8.2-8.2.7 0 1.3.1 1.9.2L17.5.5c.5-.5 1.5-.5 2 0l4 4c.6.6.6 1.5 0 2L19.9 10c.2.6.2 1.3.2 1.9 0 4.5-3.7 8.2-8.2 8.2-.7 0-1.3-.1-1.9-.2l-3.6 3.6c-.3.4-.6.5-1 .5m-1-9-3.3 3.3q-.3.3 0 .6l4 4q.3.3.6 0L9 19.6c-2.1-.8-3.8-2.5-4.6-4.6M12 4.8C8 4.8 4.8 8 4.8 12S8 19.2 12 19.2s7.2-3.2 7.2-7.2S16 4.8 12 4.8m3-.4c2.1.8 3.7 2.5 4.6 4.6l3.3-3.3q.3-.3 0-.6l-4-4q-.3-.3-.6 0zm-2.8 8.5c-.1 0-.3-.1-.4-.1l-2.1-2.1c-.2-.2-.2-.5 0-.7s.5-.2.7 0l1.9 1.9 2.4-.6c.3-.1.5.1.6.4s-.1.5-.4.6z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccessories);
export default ForwardRef;